import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3 ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        // ns-flex-wrap  ns-list-unstyled ns-m-0 ns-p-0 ns-my-2 ns-mx-0 
        <ul class="ns-d-flex ns-justify-content-center pagination-list ns-pagination ns-align-items-center ns-col-12 ns-col-l-6">
            {prev && (
                <li class="pagination-item--previous">
                    <PageLink {...pageLinkProps(prev)} className="ns-previous pagination-link" ariaLabel="Previous page">
                        {/* <Icon name="arrow" className="ns-page-prev-icon" /> */}
                        <i class="icon"><svg><use xmlnsXlink="http://www.w3.org/1999/xlink" href="#icon-chevron-left"></use></svg></i>
                        PREV
                    </PageLink>
                </li>
            )}

            {/* {first && (
                <>
                    <li class="pagination-item">
                        <PageLink {...pageLinkProps(first)} ariaLabel="First page" className="pagination-link">
                            {first.page}
                        </PageLink>
                    </li>
                    <li><span class="ns-d-block ns-py-2 ns-px-4">...</span></li>
                </>
            )} */}

            {pages.map(page => (
                <li key={page.page} class={`pagination-item ${page.current ? "ns-active pagination-item--current" : ""}`}>
                    <PageLink ariaLabel={`${page.page} page`} className="pagination-link" {...pageLinkProps(page)}>{page.page}</PageLink>
                </li>
            ))}

            {/* {last && (
                <>
                    <li><span class="ns-py-2 ns-px-4">...</span></li>
                    <li class="pagination-item">
                        <PageLink {...pageLinkProps(last)} ariaLabel="Last page" className="pagination-link">{last.page}</PageLink>
                    </li>
                </>
            )} */}

            {next && (
                <li class="pagination-item--next">
                    <PageLink {...pageLinkProps(next)} className="ns-next pagination-link" ariaLabel="Next page">
                        {/* <Icon name="arrow" className="ns-page-next-icon" /> */}
                        NEXT
                        <i class="icon" aria-hidden="true"><svg><use xmlnsXlink="http://www.w3.org/1999/xlink" href="#icon-chevron-right"></use></svg></i>
                    </PageLink>
                </li>
            )}
        </ul>
    )
}
